import { render, staticRenderFns } from "./myData.vue?vue&type=template&id=12fbd4f6&scoped=true"
import script from "./myData.vue?vue&type=script&lang=js"
export * from "./myData.vue?vue&type=script&lang=js"
import style0 from "./myData.vue?vue&type=style&index=0&id=12fbd4f6&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "12fbd4f6",
  null
  
)

export default component.exports